var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectusericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 0.333252C12.4147 0.333252 13.7712 0.895155 14.7714 1.89535C15.7716 2.89554 16.3335 4.2521 16.3335 5.66658C16.3335 7.08107 15.7716 8.43763 14.7714 9.43782C13.7712 10.438 12.4147 10.9999 11.0002 10.9999C9.58567 10.9999 8.22912 10.438 7.22893 9.43782C6.22873 8.43763 5.66683 7.08107 5.66683 5.66658C5.66683 4.2521 6.22873 2.89554 7.22893 1.89535C8.22912 0.895155 9.58567 0.333252 11.0002 0.333252V0.333252ZM11.0002 13.6666C16.8935 13.6666 21.6668 16.0533 21.6668 18.9999V21.6666H0.333496V18.9999C0.333496 16.0533 5.10683 13.6666 11.0002 13.6666Z",
    fill: "#00325C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectusericon);
export default __webpack_public_path__ + "static/media/selectusericon.9eb8e33acff7970552ebbd8ecad130bc.svg";
export { ForwardRef as ReactComponent };